<template>
    <aside class="contact">
        <ul class="contact-list">
            <!-- <li class="contact-item">
                <i class="ico-pro"></i>
                <div class="">
                    
                </div>
            </li> -->
            <li class="contact-item">
                <i class="ico-qq"></i>
                <div class="item-box qq-box">
                    <p>客服QQ：<span class="item-box-qq">839864279</span></p>
                    <p>客服群：<span class="item-box-group">767206518</span></p>
                </div>
            </li>
            <li class="contact-item">
                <i class="ico-code"></i>
                <div class="item-box code-box">
                    <div class="code-pic">
                        <img src="~Assets/img/components/hint/contact/code.png" width="104" height="104" alt="二维码">
                    </div>
                    <p class="get-code">关注公众号</p>
                </div>
            </li>
        </ul>
    </aside>
</template>
<style lang="scss" scoped>
    @import '~Assets/sass/components/hint/contact/contact.scss';
</style>
<script>
export default {}
</script>
